import React, { useCallback } from 'react';
import {
  TweaksPanel,
  TweakRadio,
  TweakSection,
} from '../Pages/XlabsTweaks';
import useInternalTheme from '../../hooks/useInternalTheme';
import { writeTheme } from '../../utils/internalTheme';
import '../Pages/XlabsTweaks.css';

/**
 * Persisted Skin tweak for xlabs stage chrome (Locate · Design · Sim lab).
 * Docs: docs/XLABS_HUB.md § Hub themes · docs/XLABS_LOCATE.md
 */
export default function XlabsThemeViewPanel() {
  const theme = useInternalTheme();
  const onTheme = useCallback((v) => {
    writeTheme(v);
  }, []);

  return (
    <TweaksPanel title="View" defaultOpen={false}>
      <TweakSection label="Theme" />
      <TweakRadio
        label="Skin"
        value={theme}
        options={[
          { value: 'light', label: 'Light' },
          { value: 'paper', label: 'Paper' },
          { value: 'blueprint', label: 'Blue' },
          { value: 'terminal', label: 'Term' },
        ]}
        onChange={onTheme}
      />
    </TweaksPanel>
  );
}
